import React, { useState, useEffect } from 'react';
import Header from './Header.js';

import configData from './Config';
import { Helmet } from 'react-helmet';

import homepage_main from './Assets/homepage_main.jpg';
import homepage_facebookicon from './Assets/homepage_facebookicon.png';
import homepage_linkedinicon from './Assets/homepage_linkedinicon.png';
import homepage_instagramicon from './Assets/homepage_instagramicon.png';
import homepage_emailicon from './Assets/homepage_emailicon.png';
import homepage_whatsappicon from './Assets/homepage_whatsappicon.png';
import homepage_appimage from './Assets/homepage_appimage.jpg';
import homepage_appstore from './Assets/appstore.png';
import homepage_playstore from './Assets/playstore.png';

import './LandingPage.css';

function LandingPage({ state, setState }) {
    const [subscriptioncode, setSubscriptioncode] = useState('');
    const [planoption, setPlanoption] = useState(1);
    const [paymentoption, setPaymentoption] = useState(1);

    const [propertytype, setPropertytype] = useState(1);
    const [propertyunits, setPropertyunits] = useState(12);
    const [propertycomplexity, setPropertycomplexity] = useState(1.3);

    const handleClose = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    }

    const handlePlan = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Plan state={state} setState={setState} />, modaltype: 'small', modaltitle: 'Plan' }))
    }

    const handleDemo = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Demo state={state} setState={setState} />, modaltype: 'small', modaltitle: 'Demo' }))
    }

    const handleApple = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <AppStore state={state} setState={setState} />, modaltype: 'small', modaltitle: 'App Store' }))
    }

    const handleWhatsapp = (text) => {
        const phoneNumber = "+96170617919";
        const encodedText = encodeURIComponent(text);
        const url = `https://wa.me/${phoneNumber}?text=${encodedText}`;

        window.open(url, "_blank", "noopener,noreferrer");
    }

    const handleRequest = () => {
        const message = `Hello, I would likfe to request a formal proposal based on the following scope estimate:

*Property Scope Details:*
• *Property Type:* ${propertytype}
• *Total Scale:* ${propertyunits} Units
• *Operational Complexity:* ${propertycomplexity}

*Estimated Investment:*
• *Monthly Range:* $5,430 – $6,920 / month
• *Annual Investment:* $65,160 – $83,040 / year

Please let me know when we can schedule the on-site technical inspection.`;

        handleWhatsapp(message)
    }

    useEffect(() => {
        let code = '';

        if (planoption === '1' && paymentoption === '1') {
            code = 'SUBBASICMONTHLY';
        } else if (planoption === '1' && paymentoption === '12') {
            code = 'SUBBASICYEARLY';
        } else if (planoption === '2' && paymentoption === '1') {
            code = 'SUBPROMONTHLY';
        } else if (planoption === '2' && paymentoption === '12') {
            code = 'SUBPROYEARLY';
        }

        setSubscriptioncode(code);
    }, [planoption, paymentoption]);

    const [monthlyMin, setMonthlyMin] = useState(0);
    const [monthlyMax, setMonthlyMax] = useState(0);
    const [annualMin, setAnnualMin] = useState(0);
    const [annualMax, setAnnualMax] = useState(0);

    useEffect(() => {
        const units = parseInt(propertyunits) || 1;
        const typeMultiplier = parseFloat(propertytype) || 1.0;
        const complexityMultiplier = parseFloat(propertycomplexity) || 1.0;

        const basePerUnit = 35 * Math.pow(units, -0.08);
        const monthlyMid = units * basePerUnit * typeMultiplier * complexityMultiplier;

        const min = Math.round(monthlyMid * 0.88 / 10) * 10;
        const max = Math.round(monthlyMid * 1.12 / 10) * 10;

        setMonthlyMin(min);
        setMonthlyMax(max);
        setAnnualMin(min * 12);
        setAnnualMax(max * 12);
    }, [propertytype, propertyunits, propertycomplexity]);

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "RealEstateAgent",
        "name": "Property Dynamics",
        "description": "Professional property management, CAFM software solutions, commercial kitchen maintenance, janitorial services, and facility operations across the region.",
        "url": "https://propertydynamics.soukakarat.com",
        "telephone": "+96170617919",
        "email": "propertydynamicsfm@gmail.com",
        "priceRange": "$$",
        "address": {
            "@type": "PostalAddress",
            "addressCountry": "LB"
        },
        "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Facilities & Property Management Services",
            "itemListElement": [
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Service",
                        "name": "Property Management & Governance"
                    }
                },
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Service",
                        "name": "Facilities & Mechanical Systems Management (CAFM)"
                    }
                },
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Service",
                        "name": "Commercial Kitchen & Restaurant Maintenance"
                    }
                },
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Service",
                        "name": "Janitorial & Deep Sanitation Services"
                    }
                }
            ]
        }
    };

    function Plan() {
        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            You’ve selected the <strong>{subscriptioncode}</strong>, and your subscription will be activated once payment is received. Please note that we are currently only accepting <strong>cash payments</strong>.
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <a
                                href={`https://wa.me/96170617919?text=Hello%2C%20I%20would%20like%20to%20subscribe%20to%20the%20${subscriptioncode}.%20Please%20provide%20payment%20details.`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Contact via WhatsApp
                            </a>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className='modal_button' onClick={handleClose}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function Demo() {
        const startDemo = () => {
            setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
            setState(state => ({
                ...state,
                user: {
                    userid: '669b5d6facee2',
                    usertoken: '1fdd91bb65550a8b03306c8f1e43b59e',
                    useremail: 'demouser@demo.com',
                    username: 'demo_user',
                    usertype: '0',
                }
            }))
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>Building XYZ 1344 Demo. Press Start Demo to start.</div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className='modal_button' onClick={startDemo}>Start Demo</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function AppStore() {
        const handleCloseAppStore = () => {
            setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>App still under development. Will be released soon.</div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className='modal_button' onClick={handleCloseAppStore}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='homepage'>
            <Helmet>
                <title>Property & Facilities Management | CAFM Cloud Software Solutions</title>
                <meta name="title" content="Property & Facilities Management | CAFM Cloud Software Solutions" />
                <meta name="description" content="High-impact operational and asset management built for commercial properties, residential developments, and specialized facilities. Access our cloud CAFM software and budget calculator today." />
                <meta name="keywords" content="property management, facilities management, CAFM software, building management system, HVAC maintenance, commercial kitchen maintenance, janitorial services, property budgeting calculator" />
                <meta name="robots" content="index, follow" />
                <meta name="language" content="English" />
                <meta name="author" content="Property Dynamics" />
                <link rel="canonical" href="https://propertydynamics.soukakarat.com/" />

                {/* Open Graph / Facebook / WhatsApp */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://propertydynamics.soukakarat.com/" />
                <meta property="og:title" content="Property & Facilities Management | CAFM Cloud Software" />
                <meta property="og:description" content="Operational excellence for residential towers, commercial complexes, and specialized facilities. Calculate your annual FM budget instantly." />
                <meta property="og:image" content={homepage_main} />

                {/* Twitter */}
                <meta property="twitter:card" content="summary_large_image" />
                <meta property="twitter:url" content="https://propertydynamics.soukakarat.com/" />
                <meta property="twitter:title" content="Property & Facilities Management | CAFM Cloud Software" />
                <meta property="twitter:description" content="Operational excellence for residential towers, commercial complexes, and specialized facilities. Calculate your annual FM budget instantly." />
                <meta property="twitter:image" content={homepage_main} />

                {/* Structured Data / JSON-LD */}
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            </Helmet>

            <Header state={state} setState={setState} />

            <div
                id="main"
                className='homepage_section'
                style={{
                    backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.8) 50%, rgba(0,0,0,0.7) 100%), url(${homepage_main})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                }}
            >
                <div className='homepage_sectioncontainer'>
                    <div className="homepage_twocontainer">
                        <div className="homepage_left">
                            <div className="homepage_maintitle">ACROSS THE REGION</div>
                            <h1 className="homepage_mainheader">Property & Facilities Management.</h1>
                            <p className="homepage_maindescription">
                                High-impact operational and asset management built for commercial properties, residential
                                developments, and specialized facilities across the region.
                            </p>

                            <div className="homepage_twocontainer">
                                <button
                                    type="button"
                                    className="homepage_button homepage_buttonorange"
                                    onClick={() => document.getElementById('calculator')?.scrollIntoView({ behavior: 'smooth' })}
                                >
                                    CALCULATE ANNUAL COST
                                </button>
                                <button type="button" onClick={() => handleWhatsapp('')} className="homepage_button homepage_buttongreen">
                                    <img className='homepage_footersocialicon' src={homepage_whatsappicon} alt="Whatsapp Icon" /> WHATSAPP US
                                </button>
                            </div>
                        </div>

                        <div className="glassmorphicmetricsbox">
                            <div className="homepage_left">
                                <div>
                                    <p className="text-xs font-black uppercase text-orange-500 tracking-widest">Proven Track Record</p>
                                </div>
                                <div className="homepage_twocontainer">
                                    <p className="text-3xl font-black text-white uppercase mt-1">Management Standards</p>
                                    <span className="text-xs font-bold text-gray-400 uppercase">Est. Portfolio</span>
                                </div>
                            </div>

                            <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
                                <div className="border-l-4 border-orange-500 pl-4 py-1">
                                    <p className="text-3xl lg:text-4xl font-black text-white">130+</p>
                                    <p className="text-xs font-bold uppercase text-gray-300 mt-1">Projects Handled</p>
                                </div>
                                <div className="border-l-4 border-white pl-4 py-1">
                                    <p className="text-3xl lg:text-4xl font-black text-orange-500">&lt; 30 Min</p>
                                    <p className="text-xs font-bold uppercase text-gray-300 mt-1">Emergency SLA Response</p>
                                </div>
                                <div className="border-l-4 border-white pl-4 py-1">
                                    <p className="text-3xl lg:text-4xl font-black text-white">99.2%</p>
                                    <p className="text-xs font-bold uppercase text-gray-300 mt-1">First-Time Fix Rate</p>
                                </div>
                                <div className="border-l-4 border-white pl-4 py-1">
                                    <p className="text-3xl lg:text-4xl font-black text-white">100%</p>
                                    <p className="text-xs font-bold uppercase text-gray-300 mt-1">Regulatory & Safety Record</p>
                                </div>
                                <div className="border-l-4 border-orange-500 pl-4 py-1">
                                    <p className="text-3xl lg:text-4xl font-black text-orange-500">15+ Yrs</p>
                                    <p className="text-xs font-bold uppercase text-gray-300 mt-1">Industry Experience</p>
                                </div>
                                <div className="border-l-4 border-white pl-4 py-1">
                                    <p className="text-3xl lg:text-4xl font-black text-white">24/7</p>
                                    <p className="text-xs font-bold uppercase text-gray-300 mt-1">Central Dispatch & Monitoring</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section id="services" className="homepage_section">
                <div className="homepage_sectioncontainer">
                    <p className="homepage_sectiontitle">Capabilities</p>
                    <h2 className="homepage_heading">Our Services</h2>

                    <div className="homepage_threecontainer">
                        <div className="homepage_card">
                            <div>
                                <h3 className="homepage_cardtitle">Property Management</h3>
                                <p className="homepage_carddescription">
                                    Complete administrative, legal, and financial management for whole residential buildings,
                                    commercial complexes, and compounds. We ensure transparent operations, high dues collection,
                                    and asset preservation.
                                </p>
                            </div>

                            <div className="homepage_cardhighlights">
                                <p className="homepage_cardhighlightstitle">Core Scope & Governance</p>
                                <div className="homepage_cardtags">
                                    <span className="homepage_cardtag">HOC</span>
                                    <span className="homepage_cardtag">Annual Budgeting</span>
                                    <span className="homepage_cardtag">Dues & Collections</span>
                                    <span className="homepage_cardtag">Financial Audits & Reports</span>
                                    <span className="homepage_cardtag">Legal & Contract Compliance</span>
                                    <span className="homepage_cardtag">Capital Reserve & Extra Projects</span>
                                </div>
                            </div>
                        </div>

                        <div className="homepage_card">
                            <h3 className="homepage_cardtitle">Facilities Management</h3>
                            <p className="homepage_carddescription">Complete engineering, mechanical,
                                electromechanical, and physical site operational oversight across all facilities.</p>
                        </div>

                        <div className="homepage_card">
                            <span className="homepage_servicenew">NEW</span>
                            <h3 className="homepage_cardtitle">Restaurant & Kitchen Maintenance</h3>
                            <p className="homepage_carddescription">Dedicated preventive and emergency
                                maintenance for commercial kitchens, HVAC extraction hoods, refrigeration, grease traps, and
                                food hygiene compliance.</p>
                        </div>

                        <div className="homepage_card">
                            <div>
                                <h3 className="homepage_cardtitle">Cleaning Services</h3>
                                <p className="homepage_carddescription">
                                    Professional janitorial, deep sanitation, and specialized hygiene management tailored to
                                    high-traffic, regulated, and sensitive operational environments.
                                </p>
                            </div>

                            <div className="homepage_cardhighlights">
                                <p className="homepage_cardhighlightstitle">Industries & Sectors Served</p>
                                <div className="homepage_cardtags">
                                    <span className="homepage_cardtag">Residential Buildings & Towers</span>
                                    <span className="homepage_cardtag">Villas & Compounds</span>
                                    <span className="homepage_cardtag">Cafes & Restaurants</span>
                                    <span className="homepage_cardtag">Hospitals & Medical Centers</span>
                                    <span className="homepage_cardtag">Schools & Universities</span>
                                    <span className="homepage_cardtag">Supermarkets & Retail Malls</span>
                                    <span className="homepage_cardtag">Corporate Offices</span>
                                    <span className="homepage_cardtag">Warehouses & Industrial Sites</span>
                                    <span className="homepage_cardtag">Public & Sports Facilities</span>
                                </div>
                            </div>
                        </div>

                        <div className="homepage_card">
                            <h3 className="homepage_cardtitle">Security Services</h3>
                            <p className="homepage_carddescription">On-site personnel deployment,
                                electronic access control, surveillance monitoring, and risk mitigation protocols.</p>
                        </div>

                        <div className="homepage_card">
                            <h3 className="homepage_cardtitle">Landscaping Services</h3>
                            <p className="homepage_carddescription">Exterior property maintenance,
                                groundskeeping, irrigation management, and seasonal landscape architecture care.</p>
                        </div>

                        <div className="homepage_card">
                            <h3 className="homepage_cardtitle">Pest Control Services</h3>
                            <p className="homepage_carddescription">Integrated pest management programs
                                ensuring clean, compliant, and healthy commercial and residential environments.</p>
                        </div>

                        <div className="homepage_card">
                            <h3 className="homepage_cardtitle">Maintenance & Repairs</h3>
                            <p className="homepage_carddescription">
                                Scheduled preventive maintenance and rapid-response emergency repair dispatches for
                                electrical, plumbing, HVAC, and mechanical systems.
                            </p>

                            <div className="homepage_cardhighlights">
                                <p className="homepage_cardhighlightstitle">Service Highlights</p>
                                <div className="homepage_cardtags">
                                    <span className="homepage_cardtag">24/7 Emergency Dispatch</span>
                                    <span className="homepage_cardtag">Instant App Request</span>
                                    <span className="homepage_cardtag">Fast Response Guarantee</span>
                                    <span className="homepage_cardtag">Quick & First-Time Fix</span>
                                    <span className="homepage_cardtag">Live Work Order Tracking</span>
                                    <span className="homepage_cardtag">Certified Techs</span>
                                </div>
                            </div>
                        </div>

                        <div className="homepage_card">
                            <h3 className="homepage_cardtitle">Energy Management</h3>
                            <p className="homepage_carddescription">Utility consumption tracking, HVAC
                                optimization, power backup integration, and efficiency audits.</p>
                        </div>

                        <div className="homepage_card">
                            <h3 className="homepage_cardtitle">Waste Management</h3>
                            <p className="homepage_carddescription">Efficient waste collection schedules,
                                recycling initiatives, and compliant environmental disposal governance.</p>
                        </div>

                        <div className="homepage_card">
                            <h3 className="homepage_cardtitle">Selling & Renting</h3>
                            <p className="homepage_carddescription">Strategic tenant placement, sales
                                broker management, property marketing, lease administration, and tenant retention.</p>
                        </div>

                        <div className="homepage_card">
                            <h3 className="homepage_cardtitle">Sustainability & Environmental</h3>
                            <p className="homepage_carddescription">ESG compliance strategies, green
                                building operational standards, and eco-friendly facility practices.</p>
                        </div>
                    </div>
                </div>
            </section>

            <div id="software" className='homepage_section'>
                <div className="homepage_sectioncontainer">
                    <p className="homepage_sectiontitle">CAFM</p>
                    <h2 className="homepage_heading">Property and Facilities Management Software</h2>
                    <p className='homepage_description'>
                        Our software offers solutions for managing properties and facilities in the cloud.
                        With our platform, you can enhance the overall effectiveness of your facilities while boosting business productivity.
                    </p>

                    <div className="homepage_twocontainer">
                        <div>
                            <img className='homepage_appimage' src={homepage_appimage} alt="App Image" />
                        </div>
                        <div className="homepage_paymentplan">
                            <div className='homepage_twocontainer'>
                                <div className='homepage_inputlabel'>Plan</div>
                                <select className='homepage_select' value={planoption} onChange={(e) => setPlanoption(e.target.value)}>
                                    <option value={1}>Basic Plan</option>
                                    <option value={2}>Pro Plan</option>
                                </select>
                            </div>
                            <div className='homepage_twocontainer'>
                                <div className='homepage_inputlabel'>Option</div>
                                <select className='homepage_select' value={paymentoption} onChange={(e) => setPaymentoption(e.target.value)}>
                                    <option value={1}>Monthly</option>
                                    <option value={12}>Yearly</option>
                                </select>
                            </div>
                            <div className='homepage_onecontainer'>
                                {planoption == 1 && paymentoption == 1 && <p className="homepage_paymentplanprice">$4/Month</p>}
                                {planoption == 1 && paymentoption == 12 && <p className="homepage_paymentplanprice">$50/Year</p>}
                                {planoption == 2 && paymentoption == 1 && <p className="homepage_paymentplanprice">$10/Month</p>}
                                {planoption == 2 && paymentoption == 12 && <p className="homepage_paymentplanprice">$110/Year</p>}
                                {planoption == 1 &&
                                    <ul className='homepage_paymentplanfeatures'>
                                        <li>Limited to 1 Project</li>
                                        <li>One-user Access</li>
                                        <li>Property Management</li>
                                        <li>Facilities Management CAFM</li>
                                    </ul>
                                }
                                {planoption == 2 &&
                                    <ul className='homepage_paymentplanfeatures'>
                                        <li>Multiple Projects</li>
                                        <li>Multi-user Access</li>
                                        <li>User Permissions</li>
                                        <li>Property Management Accounting</li>
                                        <li>Facilities Management CAFM</li>
                                        <li>Mobile App Access</li>
                                    </ul>
                                }
                            </div>
                            <div className='homepage_onecontainer'>
                                <button className='homepage_planbutton' onClick={handlePlan}>START PLAN</button>
                            </div>
                            <div className='homepage_onecontainer'>
                                <button className='homepage_demobutton' onClick={handleDemo}>DEMO Building XYZ</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section id="calculator" className="homepage_section">
                <div className="homepage_sectioncontainer">
                    <p className="homepage_sectiontitle">Dynamic Estimate</p>
                    <h2 className="homepage_heading">Annual Budget Estimator</h2>
                    <p className="homepage_description">Select your property profile to generate a tailored annual management estimate instantly.</p>

                    <div className="homepage_calculator">
                        <div className="homepage_onecontainer">
                            <div className="homepage_threecontainer">
                                <div>
                                    <label className="homepage_inputlabel">Property Type</label>
                                    <select className="homepage_select" value={propertytype} onChange={(e) => setPropertytype(e.target.value)}>
                                        <option value={1.0}>Residential Building</option>
                                        <option value={1.25}>Commercial Space</option>
                                        <option value={1.5}>Gated Compound / Mixed-Use</option>
                                    </select>
                                </div>

                                <div>
                                    <div className="flex justify-between items-center mb-1.5">
                                        <label className="homepage_inputlabel">Total Scale / Units</label>
                                        <span id="unitsValue" className="text-xs font-black text-orange-500">{propertyunits} Units</span>
                                    </div>
                                    <input type="range" min="1" max="50" value={propertyunits} onChange={(e) => setPropertyunits(Number(e.target.value))} className="home_rangeinput" />
                                </div>

                                <div>
                                    <label className="homepage_inputlabel">Operational Complexity</label>
                                    <select className="homepage_select" value={propertycomplexity} onChange={(e) => setPropertycomplexity(e.target.value)}>
                                        <option value={1.0}>Standard — Basic Financials, Reactive Repairs & Weekly Inspections
                                        </option>
                                        <option value={1.3}>Moderate — Budgeting, Scheduled System Inspections & Vendor
                                            Mgmt</option>
                                        <option value={1.7}>High — Capital Planning, Preventive MEP Audits, 24/7 Security & On-Site
                                            Mgmt</option>
                                    </select>
                                </div>
                            </div>

                            <div className="homepage_twocontainer">
                                <div>
                                    <p className="text-xs font-black uppercase text-orange-500 tracking-wider">Estimated Monthly Range</p>
                                    <p className="homepage_calculatormonthly">{monthlyMin.toLocaleString()} – ${monthlyMax.toLocaleString()}<span
                                        className="text-xs text-gray-400 font-bold">/ MONTH</span></p>
                                </div>

                                <div className="text-center md:text-right">
                                    <p className="text-xs font-black uppercase text-orange-500 tracking-wider">Estimated Annual Investment</p>
                                    <p className="homepage_calculatoryearly">${annualMin.toLocaleString()} – ${annualMax.toLocaleString()}<span
                                        className="text-xs text-gray-400 font-bold">/ YEAR</span></p>
                                </div>
                            </div>

                            <button type="button" className="homepage_button homepage_buttongreen" onClick={() => handleRequest()}>
                                <img className='homepage_footersocialicon' src={homepage_whatsappicon} alt="Whatsapp Icon" /> Request Formal Proposal Based On This Range
                            </button>

                            <p className="homepage_description">Final pricing is determined after an on-site technical inspection.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section id="contact" className='homepage_section'>
                <div className="homepage_sectioncontainer">
                    <p className="homepage_sectiontitle">Direct Inquiries</p>
                    <h2 className="homepage_heading">Executive Management Office</h2>
                    <p className="homepage_description">For new property proposals, facility management contracts, or
                        specialized service inquiries across the region.</p>

                    <div className="homepage_twocontainer">
                        <button onClick={() => handleWhatsapp('')} target="_blank" rel="noopener noreferrer" className="homepage_button homepage_buttongreen">
                            <img className='homepage_footersocialicon' src={homepage_whatsappicon} alt="Whatsapp Icon" /> WhatsApp Direct
                        </button>
                        <button href="mailto:propertydynamicsfm@gmail.com" className="homepage_button homepage_buttonblack">
                            <img className='homepage_footersocialicon' src={homepage_emailicon} alt="Email Icon" /> Email Us
                        </button>
                    </div>
                </div>
            </section>

            <section id="apps" className="homepage_section">
                <div className="homepage_sectioncontainer">
                    <p className="homepage_sectiontitle">Apps</p>
                    <h2 className="homepage_heading">Download our Apps</h2>
                    <p className="homepage_description">
                        Download our apps from Google Play Store and App Store
                    </p>

                    <div className="homepage_twocontainer">
                        <a
                            className="homepage_button homepage_buttonblack"
                            href={configData.ANDROIDLINK}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Play Store"
                        >
                            <img className="homepage_appimage" src={homepage_playstore} alt="Play Store" />
                        </a>

                        <button
                            type="button"
                            className="homepage_button homepage_buttonblack"
                            onClick={handleApple}
                            title="App Store"
                        >
                            <img className="homepage_appimage" src={homepage_appstore} alt="App Store" />
                        </button>
                    </div>
                </div>
            </section>

            <footer className="homepage_footer">
                <div className="homepage_footercontainer">
                    <div className="homepage_footerbrand">
                        <p className="homepage_footername">PROPERTY DYNAMICS</p>
                        <p className="homepage_footertagline">POWERFUL PROFESSIONAL MANAGEMENT</p>
                    </div>

                    <div className="homepage_socialicons">
                        <a className="homepage_footersocialiconcontainer" href={configData.FACEBOOKLINK} target="_blank" rel="noopener noreferrer" title="Facebook">
                            <img className='homepage_footersocialicon' src={homepage_facebookicon} alt="Facebook Icon" />
                        </a>
                        <a className="homepage_footersocialiconcontainer" href={configData.LINKEDINLINK} target="_blank" rel="noopener noreferrer" title="LinkedIn">
                            <img className='homepage_footersocialicon' src={homepage_linkedinicon} alt="LinkedIn Icon" />
                        </a>
                        <a className="homepage_footersocialiconcontainer" href={configData.INSTAGRAMLINK} target="_blank" rel="noopener noreferrer" title="Instagram">
                            <img className='homepage_footersocialicon' src={homepage_instagramicon} alt="Instagram Icon" />
                        </a>
                        <a className="homepage_footersocialiconcontainer" href="mailto:propertydynamicsfm@gmail.com" title="Email">
                            <img className='homepage_footersocialicon' src={homepage_emailicon} alt="Email Icon" />
                        </a>
                        <a className="homepage_footersocialiconcontainer" onClick={() => handleWhatsapp('')} target="_blank" rel="noopener noreferrer" title="WhatsApp">
                            <img className='homepage_footersocialicon' src={homepage_whatsappicon} alt="Whatsapp Icon" />
                        </a>
                    </div>

                    <p className="homepage_footercopyright">© 2026 PROPERTY DYNAMICS. ALL RIGHTS RESERVED.</p>
                </div>
            </footer>

        </div>
    );
}

export default LandingPage;